/**
 * Cardo — Design Tokens
 *
 * Brand colors, typography scale, and shared constants.
 * Used by all components for consistency.
 */

export const colors = {
  bg: "#0A0A0A",
  surface: "#131313",
  raised: "#1A1A1A",
  border: "#252525",
  borderHi: "#333",
  text: "#F5F3EE",
  text2: "#A0A0A0",
  muted: "#6B6B6B",
  amber: "#E8912D",
  amberLt: "#F0A84D",
  amberGlow: "rgba(232,145,45,0.10)",
  red: "#D94F4F",
  redGlow: "rgba(217,79,79,0.10)",
  green: "#4CAF7D",
  greenGlow: "rgba(76,175,125,0.10)",
  blue: "#5B9BD5",
  purple: "#9B7ED8",
} as const;

export const riskColors: Record<string, string> = {
  low: colors.green,
  moderate: colors.amber,
  high: colors.amberLt,
  critical: colors.red,
};

export const fonts = {
  body: "'DM Sans', -apple-system, sans-serif",
  mono: "'Space Mono', monospace",
} as const;

/** Map a 0–100 component score to its threshold color. */
export function scoreToColor(score: number): string {
  return score >= 70 ? colors.red : score >= 40 ? colors.amber : colors.green;
}
